import React from 'react';

import styled from 'styled-components';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {gt} from 'app/utils/i18n';

export function HotlinkWarning(): JSX.Element {
  const [mounted, setMounted] = React.useState<boolean>(false);
  React.useEffect(() => {
    setMounted(true);
  }, []);
  return (
    <LazyTooltip
      tooltip={gt("We couldn't download this image. Please copy and paste it.")}
    >
      <StyledContainerDiv className="position-absolute" mounted={mounted}>
        <i className="fas fa-exclamation-triangle text-warning" />
      </StyledContainerDiv>
    </LazyTooltip>
  );
}

const StyledContainerDiv = styled.div<{mounted: boolean}>`
  right: 8px;
  top: 8px;
  background: rgba(255, 255, 255, 1);
  width: 20px;
  height: 20px;
  padding-bottom: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  font-size: 9pt;
  opacity: ${({mounted}) => (mounted ? '1' : '0')};
  transition: opacity 0.5s ease-in-out;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);
`;
